<template lang="pug">
  CommonSection(v-if="task && project" :title="task.name" :crossed="task.isClosed" :back="{ title: project.name, name: 'project-stages', hash: `#${stageId}`, params: { projectId } }")
    PageScroller
    .b-task-detail
      ._main
        FormBlock(mobile)._main-info
          ._header
            UserAssigningTile._header-users(
              :from="task.author"
              :to="task.manager"
              :fromEditable="access.canUpdateTask(true)"
              :toEditable="access.canUpdateTask(true)"
              @fromChanged="task.author = $event"
              @toChanged="task.manager = $event"
              :items="$store.getters['project/members']"
              label="Нет исполнителя"
              emptyLabel="Нет участников проекта"
            )
            TaskStatus._header-item(
              v-model="task.status"
              :project="project"
              :changeable="access.canUpdateTask()"
              :editable="access.canEditProject()"
              @edited="project.taskStatuses = $event"
            )
            BasePriority._header-item(v-model="task.priority" :editable="access.canUpdateTask(true)")
            BaseBookmark._header-item
            EllipsisMenu._header-item(:items="ellipsisMenuItems")
          ._subheader
            div
              DateProgressbar._progress(:dateProgress="dateProgress" :editable="access.canUpdateTask(true)" @dateChange="onDateUpdated")
              ._updated-at(v-if="updatedAt") ред. {{ updatedAt }}
            TaskReminder(:task="task")
          BaseText(v-if="task.description" v-html="task.description")
          CheckList(v-model="task.checklist" :id="task.id" :editable="access.canUpdateTask(true)" :changeable="access.canUpdateTask()")
          FileList(
            :files="task.projectFiles"
            downloadAll
            zoom
            :attached="attachedFiles"
            :attachable="attachable"
            @attach="attach"
            @detach="detach"
          )
            //template(#buttons)
          ._buttons
            template(v-if="access.canUpdateTask(true)")
              Btn(v-if="task.isClosed" @click="task.isClosed = false" narrow) Открыть задачу
              Btn(v-else grey @click="task.isClosed = true" narrow) Закрыть задачу
            template(v-if="access.isTaskManager()")
              Btn(green v-if="task.status === 'new'" @click="setStatus('progress')" narrow) Начать выполнение
              Btn(green v-else-if="task.status === 'rework'" @click="setStatus('progress')" narrow) Продолжить выполнение
              template(v-else-if="task.status === 'progress'")
                Btn(@click="setStatus('review')" narrow) На проверку
                Btn(@click="setStatus('paused')" narrow) Поставить на паузу
              Btn(v-else-if="task.status === 'paused'" @click="setStatus('progress')" narrow) Продолжить выполнение
        template(v-if="!project.isTemplate")
          TaskDetailHistory._block(
            v-if="access.isProjectAuthor() || access.isProjectMember()"
            ref="history"
            :task="task"
            :project="project"
            :allowToEditComments="access.isProjectEditable()"
            :access="access"
            :attachedFiles="attachedFiles"
            :attachable="attachable"
            @reply="replyToComment"
            @attach="attach"
            @detach="detach"
          )
          TaskDetailCommentAddForm(
            v-if="access.isProjectEditable()"
            ref="commentAddForm"
            :task="task"
            @publish="onCommentPublished"
            @scrollToComment="scrollToComment"
          )
      ._aside
        FormBlock(mobile)._block.-watchers
          ._header.-underline
            ._title Наблюдатели
            BaseTooltip._tooltip(text="Наблюдатели видят только те задачи, в которых принимают участие")
            Icon(name="edit2" @click.native="membersSelectPopupOpened = true" pointer v-if="access.canUpdateTask(true)")
            UserSelectPopup(v-if="membersSelectPopupOpened" @close="membersSelectPopupOpened = false" v-model="task.members" :items="$store.getters['project/members']" multiple)
          ._members(v-if="task.members && task.members.length")
            UserTile._member(v-for="member in task.members" :key="member.id" :user="member")
          EmptyList(v-else) Нет наблюдателей
        FormBlock(mobile)._block.-stages
          StageAsideTile(:currTask="task" :tasks="tasks" :isAdmin="access.canEditProject()")
        router-link._back-to-project(:to="{ name: 'project-stages', params: { ...$route.params } }")
          Btn(xl dark) Вернуться к проекту
</template>

<script>
import taskListModel from '@/model/taskList';
import taskApi from '@/api/task';
import projectApi from '@/api/project';
import projectFileAttachApi from '@/api/projectFileAttach';

import Access from '@/utils/access';
import dateProgress from '@/utils/dateProgress';
import utils from '@/utils/common';

import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import UserAssigningTile from '@/components/UserAssigningTile.vue';
import BasePriority from '@/components/BasePriority.vue';
import TaskStatus from '@/components/task/TaskStatus.vue';
import DateProgressbar from '@/components/DateProgressbar.vue';
import FileList from '@/components/FileList.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import BaseBookmark from '@/components/BaseBookmark.vue';
import BaseText from '@/components/BaseText.vue';
import BaseTooltip from '@/components/BaseTooltip.vue';
import UserTile from '@/components/UserTile.vue';
import TaskDetailHistory from '@/components/task/detail/TaskDetailHistory.vue';
import StageAsideTile from '@/components/StageAsideTile.vue';
import UserSelectPopup from '@/components/UserSelectPopup.vue';
import CheckList from '@/components/checlkist/CheckList.vue';
import PageScroller from '@/components/PageScroller.vue';
import EmptyList from '@/components/ui/EmptyList.vue';
import TaskDetailCommentAddForm from '@/components/task/detail/TaskDetailCommentAddForm.vue';
import modelPopup from '@/model/popup';
import TaskCopyPopup from '@/components/task/TaskCopyPopup.vue';
import TaskReminder from '@/components/task/TaskReminder.vue';

export default {
  name: 'TaskDetail',
  components: {
    TaskDetailCommentAddForm,
    EmptyList,
    PageScroller,
    UserTile,
    BaseTooltip,
    BaseText,
    BaseBookmark,
    EllipsisMenu,
    FileList,
    DateProgressbar,
    TaskStatus,
    BasePriority,
    UserAssigningTile,
    FormBlock,
    CommonSection,
    TaskDetailHistory,
    StageAsideTile,
    UserSelectPopup,
    CheckList,
    TaskReminder,
  },
  data() {
    return {
      task: null,
      stage: null,
      project: null,
      attaches: [],
      membersSelectPopupOpened: false,
    };
  },
  computed: {
    taskId() { return parseInt(this.$route.params.taskId, 10); },
    stageId() { return parseInt(this.$route.params.stageId, 10); },
    projectId() { return parseInt(this.$route.params.projectId, 10); },
    dateProgress() { return dateProgress(this.task.dateStart, this.task.dateFinish, null, true); },
    access() { return new Access({ ...this.task, project: this.project }, this.$store.state.auth.user); },
    tasks() { return this.$store.getters['taskList/byStages'][this.stageId] ?? []; },
    updatedAt() { return this.task.updatedAt ? utils.convertDateToString(new Date(this.task.updatedAt), 'short', true) : ''; },
    attachable() { return this.access.canEditProject() || this.access.isTaskAuthor(); },
    attachedFiles() { return this.task.projectFileAttaches.map(a => ({ ...a.projectFile, attach: a['@id'] })); },
    ellipsisMenuItems() {
      const items = [];

      if (this.access.canUpdateTask(true)) {
        items.push({ text: 'Редактировать', icon: 'edit', route: { name: 'task-edit', params: { ...this.$route.params } } });

        items.push(
          this.task.isClosed
            ? { text: 'Открыть', icon: 'close', handler: () => { this.task.isClosed = false; } }
            : { text: 'Закрыть', icon: 'close', handler: () => { this.task.isClosed = true; } },
        );

        items.push({ text: 'Копировать',           icon: 'edit',   handler: () => { this.copyTask('task'); } }); // eslint-disable-line
        items.push({ text: 'Копировать чеклист',   icon: 'edit',   handler: () => { this.copyTask('checklist'); } });  // eslint-disable-line

        items.push({ text: 'Удалить', icon: 'trash', handler: this.deleteTask });
      }

      return items;
    },
  },
  watch: {
    'task.isClosed':   function (newVal, oldVal) { this.updateTask('isClosed',   newVal, oldVal, newVal ? 'Задача закрыта' : 'Задача открыта');  }, // eslint-disable-line
    'task.status':     function (newVal, oldVal) { this.updateTask('status',     newVal, oldVal, 'Статус изменен');                              }, // eslint-disable-line
    'task.priority':   function (newVal, oldVal) { this.updateTask('priority',   newVal, oldVal, 'Приоритет изменен');                           }, // eslint-disable-line
    'task.author':     function (newVal, oldVal) { this.updateTask('author',     newVal, oldVal, 'Автор изменен');                               }, // eslint-disable-line
    'task.manager':    function (newVal, oldVal) { this.updateTask('manager',    newVal, oldVal, 'Ответственный изменен');                       }, // eslint-disable-line
    'task.members':    function (newVal, oldVal) { this.updateTask('members',    newVal, oldVal, 'Список наблюдателей изменен');                 }, // eslint-disable-line
    'task.checklist':  function (newVal, oldVal) { this.updateTask('checklist',  newVal, oldVal, '');                                            }, // eslint-disable-line
    'task.dateStart':  function (newVal, oldVal) { this.updateTask('dateStart',  newVal, oldVal, 'Дата начала изменена');                        }, // eslint-disable-line
    'task.dateFinish': function (newVal, oldVal) { this.updateTask('dateFinish', newVal, oldVal, 'Дата завершения изменена');                    }, // eslint-disable-line
    task(val) {
      if (!val) return;

      setTimeout(() => {
        const getter = this.$store.getters['notification/itemIdsByFilter'];
        const notifications = getter({ taskId: this.task.id });
        notifications
          .filter(n => !n.info.commentId)
          .forEach(n => this.$store.dispatch('notification/view', n));
      }, 3000);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(fullReload = true) {
      taskApi.fetchItem(this.taskId, {}, true).then((r) => {
        this.task = r;
        document.title = r.name;
      });
      projectApi.fetchItem(this.projectId, true).then((r) => { this.project = r; });

      if (!fullReload) return;

      taskListModel.fetch({ stage: this.stageId });
      this.$store.dispatch('project/fetchProject', { projectId: this.projectId });
    },

    onCommentPublished(comment) { this.$refs.history.extAdd(comment); },
    scrollToComment(comment) { this.$refs.history.scrollToComment(comment); },
    replyToComment(comment) { this.$refs.commentAddForm.extReply(comment); },

    updateTask(field, newVal, oldVal, message) {
      if (oldVal === undefined) return;

      let valueToUpdate = newVal;

      if (field === 'author') valueToUpdate = newVal?.['@id'] ?? null;
      if (field === 'manager') valueToUpdate = newVal?.['@id'] ?? null;
      if (field === 'members') valueToUpdate = newVal.map(m => m['@id']);

      taskApi.update(this.task.id, { [field]: valueToUpdate })
        .then(() => { if (message) this.$push({ text: message }); })
        .catch(() => { this.$push({ text: 'При сохранении произошла ошибка!' }); });
    },
    onDateUpdated({ position, value }) {
      this.task[`date${position}`] = value;
    },
    setStatus(status) {
      this.task.status = status;
    },
    copyTask(mode) {
      modelPopup.add({
        args: [mode, this.task.id],
        component: TaskCopyPopup,
      });
    },
    async deleteTask() {
      if (await this.$confirm('Вы действительно хотите удалить задачу?')) {
        taskApi.delete(this.task.id, true)
          .then(() => {
            this.$router.push({
              name: 'project-stages',
              params: { projectId: this.task.stage.project.id },
            });
          })
          .catch(() => {
            this.$alert('При удалении произошла ошибка');
          });
      }
    },
    async attach(file) {
      const projectFile = file['@id'];
      const task = this.task['@id'];
      const created = await projectFileAttachApi.create({ projectFile, task }, true);
      this.task.projectFileAttaches = [...this.task.projectFileAttaches, created];
    },
    async detach(file) {
      const found = this.task.projectFileAttaches.find(a => a.projectFile.id === file.id);
      if (!found) return;

      await projectFileAttachApi.delete(found.id, true);
      this.task.projectFileAttaches = this.task.projectFileAttaches.filter(a => a !== found);
    },
  },
};
</script>

<style scoped lang="scss">
.task-detail {
  display: grid;
  grid-template-columns: 8fr 4fr;
  grid-column-gap: 40px;

  &__main {
    //grid-column: 8 span;
  }

  &__aside {
    //grid-column: 4 span;
    position: relative;
    padding-bottom: 100px;
  }

  &__back-to-project {
    position: absolute;
    bottom: 30px;
    right: 0;
  }

  &__block {
    margin-bottom: 30px;
  }

  &__main-info {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    gap: 30px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;

    &--underline {
      border-bottom: 1px solid var(--color-super-light);
      padding-bottom: 24px;
      margin-bottom: 24px;
    }
  }

  &__subheader {
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: 30px;
  }

  &__buttons {
    display: flex;
    gap: 25px;
  }

  &__title {
    font-size: 17px;
    line-height: 24px;
  }

  &__tooltip {
    margin: 0 auto 0 0;
  }

  &__header-users {
    margin-right: auto;
  }

  &__progress {
    width: 350px;
    max-width: 100%;
  }

  &__updated-at {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: var(--color-middle-gray);
    margin-top: 10px;
  }

  &__member {
    padding: 6px 14px;
    background: var(--main-bg);
    margin-bottom: 10px;
  }

  @media (max-width: 1500px) {
    grid-template-columns: 12fr 5fr;
    grid-column-gap: 20px;
  }

  @media (max-width: 1249px) {
    grid-column-gap: 0;
    grid-template-columns: minmax(0, 1fr);

    &__main {
      grid-column: 1;
      display: contents;
    }

    &__aside {
      grid-column: 1;
      //grid-row: 2;
      display: contents;
    }

    &__back-to-project {
      display: none;
      //position: static;
      //justify-self: end;
    }

    &__block {
      &--watchers {
        grid-row: 2;
      }
      &--stages {
        //display: none;
      }
    }
  }

  @media (max-width: 1000px) {
    &__header {
      flex-wrap: wrap;
    }

    &__header-item {
      &:last-child {
        margin-left: auto;
        //margin-right: auto;
      }
    }

    &__header-users {
      width: 100%;
      order: 10;
    }

    &__progress {
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    &__block {
      margin-bottom: 20px;
    }

    &__subheader {
      grid-template-columns: 1fr;
    }
  }
}
</style>
